import { IssuesTableRow } from './issues-table-row';
import { StreamQualityReportResponseDto } from '../stream-quality.types';

function isValidDate(d: Date): boolean {
  return !Number.isNaN(d.getTime());
}

/**
 * Flattens report station rows into chronological issue/gap records for the results table.
 * Stream gaps use ISO `start`/`end`; a null `end` is treated as the report window end (same as the timeline chart).
 */
export function buildIssuesTableRows(report: StreamQualityReportResponseDto): IssuesTableRow[] {
  const globalEnd = new Date(report.data.to);
  const rows: IssuesTableRow[] = [];

  for (const stationRow of report.result.byStation) {
    const { stationId } = stationRow;

    for (const issue of stationRow.audioQualityIssues) {
      const startAt = new Date(issue.start);
      const endAt = new Date(issue.end);
      if (!isValidDate(startAt) || !isValidDate(endAt)) {
        continue;
      }
      rows.push({
        id: `issue-${stationId}-${issue.start}-${issue.end}-${issue.kind}`,
        stationId,
        payload: {
          type: 'issue',
          start: startAt,
          end: endAt,
          stationId,
          issue,
        },
      });
    }

    for (const gap of stationRow.streamGaps) {
      if (!gap.start) {
        continue;
      }
      const startAt = new Date(gap.start);
      const endAt = gap.end ? new Date(gap.end) : globalEnd;
      if (!isValidDate(startAt) || !isValidDate(endAt)) {
        continue;
      }
      rows.push({
        id: `gap-${gap.id}`,
        stationId,
        gapDurationMs: gap.durationMs,
        payload: {
          type: 'gap',
          start: startAt,
          end: endAt,
          stationId,
          gap,
        },
      });
    }
  }

  rows.sort((a, b) => a.payload.start.getTime() - b.payload.start.getTime());
  return rows;
}
